import ShownAds from 'modules/acount/shownAds';
import Header from 'modules/header/wholesaler/main';

const ShownAdsPage = () => {
  return (
    <>
      <Header title="آگهی‌های نشان شده" />
      <ShownAds app="wholesaler" />
    </>
  );
};

export default ShownAdsPage;
